/**
 * OSHomePage — RunAI WebOS Desktop
 * Boot animasyonu + Desktop
 * KURAL 3: Emoji ikon YASAK — lucide-react kullanılır
 */
import { Bot } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Desktop } from '../../components/os'

export default function OSHomePage() {
  const [booted, setBooted] = useState(false)

  useEffect(() => {
    // Boot animasyonu — 600ms sonra desktop görünür
    const t = setTimeout(() => setBooted(true), 600)
    return () => clearTimeout(t)
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', position: 'relative' }}>
      {/* Boot overlay */}
      <div style={{
        position: 'absolute', inset: 0, zIndex: booted ? -1 : 100,
        background: 'var(--os-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center',
        opacity: booted ? 0 : 1, transition: 'opacity 0.5s ease',
        pointerEvents: booted ? 'none' : 'auto',
      }}>
        <div style={{ textAlign: 'center', animation: 'bootPulse 1.5s ease infinite' }}>
          <div style={{
            width: 56, height: 56, borderRadius: 16,
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 14px',
            boxShadow: '0 8px 32px rgba(99,102,241,0.4)',
          }}>
            <Bot size={30} color="#fff" strokeWidth={2} />
          </div>
          <div style={{ fontSize: 17, fontWeight: 700, color: 'var(--os-text-strong)', letterSpacing: 1 }}>RunAI OS</div>
          <div style={{ fontSize: 11, color: 'var(--os-muted)', marginTop: 4 }}>Loading workspace…</div>
        </div>
      </div>
      <style>{`@keyframes bootPulse { 0%,100% { opacity: 0.7; transform: scale(1) } 50% { opacity: 1; transform: scale(1.05) } }`}</style>
      <Desktop />
    </div>
  )
}
